import { MenuItem } from "@mui/material";
import { memo, useEffect, useMemo } from "react";
import MuiSelect from "../../shared/MuiSelect";
import { useQuery } from "react-query";
import { getSpecificationTypes } from "../../Services/SpecificationTypes";

const FormSelectSpecificationType = ({
  specificationType,
  setSpecificationType,
  specificationTypeName,
  categoryId,
}) => {
  const { data: specificationTypeData } = useQuery(
    ["specificationTypeData", categoryId],
    () => getSpecificationTypes({ maincategory: categoryId }),
    {
      enabled: Boolean(categoryId),
    }
  );

  const specificationTypes = useMemo(
    () => specificationTypeData?.data?.data,
    [specificationTypeData]
  );

  useEffect(() => {
    if (specificationTypeName) {
      setSpecificationType(
        specificationTypes?.find(
          (item) => item.specification_name === specificationTypeName
        ).id
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MuiSelect
      name="specification_type_id"
      id="specification_type_id"
      className="!w-full"
      label="Specification Type"
      placeholder="Select Specification Type"
      value={specificationType}
      onChange={(event) => setSpecificationType(event.target.value)}
    >
      {specificationTypes?.map((item) => {
        return (
          <MenuItem key={item.id} value={item.id}>
            {item.specification_name}
          </MenuItem>
        );
      })}
    </MuiSelect>
  );
};

export default memo(FormSelectSpecificationType);
